// Tiny in-page registry so the v0.5 pieces find each other without the booth
// UI having to wire every one of them (it may, explicitly, too):
//   PersonPipeline ──onPoseFrame──▶ BoothRoom.sendPoseFrame   (auto when the room's
//                                                             local stream carries the
//                                                             pipeline's packed track)
//   Stage layer whose source is a pipeline's packed canvas → that pipeline's poses
//   Stage layer whose source is a <video> (the partner)     → room.remotePoses
//   ShootController at the shutter → stage.snapshot()        (decision for the still)
// Browser-only; holds no state across sessions (members unregister on dispose).

import type { PoseFrame, PoseRing } from '../booth/pose';
import type { Decision, LayoutState } from '../booth/solver';

export interface PipelineLike {
  readonly packed: HTMLCanvasElement;
  readonly poses: PoseRing;
  readonly stream: MediaStream;
  addPoseListener(cb: (p: PoseFrame) => void): () => void;
}

export interface RoomLike {
  readonly selfId: string;
  readonly partnerId: string | null;
  readonly remotePoses: PoseRing;
}

export interface StageLike {
  /** decision + layout frozen at this instant (for the still, US7) */
  snapshot(): { decision: Decision; layout: LayoutState } | null;
}

export const registry = {
  pipelines: new Set<PipelineLike>(),
  room: null as RoomLike | null,
  stage: null as StageLike | null,
};

/** ML timing shared with stage.perf() (milliseconds, smoothed). */
export const perfCounters = { mlMs: 0 };
